// https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
export const toBase64WithUnicode = (stringMayHaveUnicode: string) =>
  btoa(
    encodeURIComponent(stringMayHaveUnicode).replace(/%([0-9A-F]{2})/g, (_, unicode) =>
      String.fromCharCode(parseInt(unicode, 16)),
    ),
  );

export const toStringFromBase64WithUnicode = (base64MayHaveUnicode: string) =>
  decodeURIComponent(
    Array.prototype.map
      .call(
        atob(base64MayHaveUnicode),
        (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2),
      )
      .join(''),
  );
